import { memo } from "react";

import type { BillingStatus, TicketListAvailable_BillingPageQuery } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import {
	ProTicketCurrentStatusSection,
	ProTicketCurrentTicketSection,
	ProTicketRecurringPurchaseTicketSection,
} from "./components";

import type {
	BillingSettingDialogStateType,
	BillingSettingDialogType,
	OnUpdatePurchaseProBillingTicketType,
	OnUpdateRecurringPurchaseProBillingTicketType,
} from "../../../../../../model/use-case";

type Props = {
	ticketProListAvailableSingleBilling: TicketListAvailable_BillingPageQuery["ticketProListAvailableSingleBilling"];
	ticketProListAvailableContinuousBilling: TicketListAvailable_BillingPageQuery["ticketProListAvailableContinuousBilling"];

	isUsingPro: boolean;
	billingStatus: BillingStatus;
	onPurchaseProBillingTicket: OnUpdatePurchaseProBillingTicketType;
	onRecurringPurchaseProBillingTicket: OnUpdateRecurringPurchaseProBillingTicketType;

	openBillingSettingDialog: BillingSettingDialogStateType;
	handleOpenChange: (type: BillingSettingDialogType) => (callBackFunc: NodeJS.Timeout) => (open: boolean) => void;
	activateBillingSettingDialog: (type: BillingSettingDialogType) => void;
	deactivateBillingSettingDialog: (type: BillingSettingDialogType) => void;
};

export const IslandProTicket = memo(
	({
		ticketProListAvailableSingleBilling,
		ticketProListAvailableContinuousBilling,

		isUsingPro, //
		billingStatus,
		onPurchaseProBillingTicket,
		onRecurringPurchaseProBillingTicket,

		openBillingSettingDialog,
		handleOpenChange,
		activateBillingSettingDialog,
		deactivateBillingSettingDialog,
	}: Props) => {
		return (
			<FeatureIslandMainWithBackGround islandTitle="予約手数料">
				<ProTicketCurrentStatusSection
					isUsingPro={isUsingPro}
					ticketProListAvailableSingleBilling={ticketProListAvailableSingleBilling}
					billingStatus={billingStatus}
					onPurchaseProBillingTicket={onPurchaseProBillingTicket}
					openBillingSettingDialog={openBillingSettingDialog}
					handleOpenChange={handleOpenChange}
					activateBillingSettingDialog={activateBillingSettingDialog}
					deactivateBillingSettingDialog={deactivateBillingSettingDialog}
				/>

				{isUsingPro && (
					<>
						<ProTicketCurrentTicketSection
							ticketProListAvailableSingleBilling={ticketProListAvailableSingleBilling}
							billingStatus={billingStatus}
							onPurchaseProBillingTicket={onPurchaseProBillingTicket}
							openBillingSettingDialog={openBillingSettingDialog}
							handleOpenChange={handleOpenChange}
							activateBillingSettingDialog={activateBillingSettingDialog}
							deactivateBillingSettingDialog={deactivateBillingSettingDialog}
						/>

						<ProTicketRecurringPurchaseTicketSection
							ticketProListAvailableContinuousBilling={ticketProListAvailableContinuousBilling}
							billingStatus={billingStatus}
							onRecurringPurchaseProBillingTicket={onRecurringPurchaseProBillingTicket}
							openBillingSettingDialog={openBillingSettingDialog}
							handleOpenChange={handleOpenChange}
							activateBillingSettingDialog={activateBillingSettingDialog}
							deactivateBillingSettingDialog={deactivateBillingSettingDialog}
						/>
					</>
				)}
			</FeatureIslandMainWithBackGround>
		);
	},
);

IslandProTicket.displayName = "IslandProTicket";
